import { apiURL } from 'config/baseURL';
import { gatewayFetch } from 'helpers/api';

const postCheckIsSandbox = async (email: string) => {
	try {
		const options: RequestInit = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ email }),
		};
		const url = `${apiURL}/auth/sandbox/is-sandbox-organization`;
		await gatewayFetch(url, options);
	} catch (error) {
		// intended due to browser logging
		console.error(error);
	}
};

export default postCheckIsSandbox;
